module.exports = __webpack_public_path__ + "img/horizontal_7_1_7005.738e2934.png";